import { paramusConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function ParamusPage() {
  return <CityPageTemplate config={paramusConfig} />;
}